import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles'
import injectTapEventPlugin from 'react-tap-event-plugin'
import App from './containers/App'
import Routes from './Routes'
import { theme } from './config'
import createStore from './store/createStore'

const store = createStore()

injectTapEventPlugin()
ReactDOM.render((
  <MuiThemeProvider theme={createMuiTheme(theme)}>
    <Provider store={store}>
      <Routes />
    </Provider>
  </MuiThemeProvider>
), document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js